// IMAGE_DATA_DIRECTORY indexes.
export const IDD_RESOURCE = 2;
export const IDD_EXCEPTION = 3;
export const IDD_BASE_RELOCATION = 5;
export const IDD_RESERVED = 15;

// IMAGE_SECTION_HEADER characteristics.
export const IMAGE_SCN_CNT_CODE = 0x00000020;
export const IMAGE_SCN_CNT_INITIALIZED_DATA = 0x00000040;
export const IMAGE_SCN_CNT_UNINITIALIZED_DATA = 0x00000080;
export const IMAGE_SCN_MEM_SHARED = 0x10000000;
export const IMAGE_SCN_MEM_EXECUTE = 0x20000000;
export const IMAGE_SCN_MEM_READ = 0x40000000;
export const IMAGE_SCN_MEM_WRITE = 0x80000000;
